import React from "react";

export default function Publications() {
  return (
    <div style={{ marginTop: "7rem" }}>
      <div class="container">
        <div class="about">
          <div class="card border-primary mb-3" style={{ width: "auto" }}>
            <div class="card-body">
              <h5 class="card-title text-primary">PUBLICATION</h5>
              <h6 class="card-subtitle mb-2 text-muted">&nbsp;</h6>
              <div style={{ margin: "1rem" }}>
                <strong>
                  Technically supported by IDES. <br />
                  <br />
                  All the accepted registered papers will be published by the
                  <span className="text-primary">
                    {" "}
                    <a
                      href="http://thegrenze.com/index.php?display=page&view=journaldetails&id=8"
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      GRENZE SCIENTIFIC SOCIETY
                    </a>{" "}
                  </span>
                  and will be indexed in Scopus.
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
